export enum ClickAreaType {
    APT = "apt",
    VIEW = "view",
    EXT = "ext"
}
